
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surah/read",
      function () {
        return require("private-next-pages/surah/read/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surah/read"])
      });
    }
  